export const DatePickersView = Backbone.View.extend({

  /**
   * Init Datepicker view
   * @param options
   */
  initialize: function (options) {
    this.setElement(options.element);
    this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.wordingsDays = GLOBAL_SCRIPTS.WORDING_DAYS;
    this.model = options.model;
    this.mainEngineModel = this.model.get('mainSearch');
    this.temporaryModel = this.model.get('temporarySearch');
    this.calendarsPicker = [];
    this.datePickerOptions = typeof options.datePickerOptions !== 'undefined' ? options.datePickerOptions : {};
    this.$arrivalDate = this.$el.find('.js-search-date_begin');
    this.$arrivalDateInput = this.$el.find('.js-search-arrivalInput');
    this.$arrivalBlock = this.$el.find('.js-searchForm-arrivalDateBlock');
    this.$arrivalDay = this.$el.find('.js-search-arrivalDay');
    this.$departureDate = this.$el.find('.js-search-date_end');
    this.$departureDateInput = this.$el.find('.js-search-departureInput');
    this.$departureBlock = this.$el.find('.js-searchForm-departureDateBlock');
    this.$departureDay = this.$el.find('.js-search-departureDay');
    this.arrivalDatepicker = {};
    this.departureDatepicker = {};
    this.wordingArrival = typeof wordingJS_arrivalDate !== 'undefined' ? wordingJS_arrivalDate : '';
    this.wordingDeparture = typeof wordingJS_departureDate !== 'undefined' ? wordingJS_departureDate : '';
    this.isDayVisitor = typeof isDayVisitor !== 'undefined' && isDayVisitor;
    this.isHome = $('body').hasClass('home');

    this.initListener();
    this.initDatepicker(this, this.datePickerOptions);

    resize.addToFunctionList(this.initDatepicker, true, this);
  },

  initListener: function () {
    this.stopListening(dispatcher, 'facette:dates:handleCalendarDisplay');
    this.listenTo(dispatcher, 'facette:dates:display', this.handleCalendarDisplay);

    this.stopListening(dispatcher, 'facette:dates:displayCalendarValidation');
    this.listenTo(dispatcher, 'facette:dates:displayCalendarValidation', this.displayCalendarValidation);

    this.stopListening(dispatcher, 'facette:dates:resetDate');
    this.listenTo(dispatcher, 'facette:dates:resetDate', this.resetDate);

    this.stopListening(dispatcher, 'facette:dates:updateDateFieldLabel');
    this.listenTo(dispatcher, 'facette:dates:updateDateFieldLabel', this.updateDateFieldLabel);

    this.stopListening(dispatcher, 'facette:dates:updateDate');
    this.listenTo(dispatcher, 'facette:dates:updateDate', this.updateDate);

    this.stopListening(dispatcher, 'facette:dates:resetDepartureDate');
    this.listenTo(dispatcher, 'facette:dates:resetDepartureDate', this.resetDepartureDate);

    this.stopListening(dispatcher, 'facette:dates:updateDisabledStatusAndResetBtn');
    this.listenTo(dispatcher, 'facette:dates:updateDisabledStatusAndResetBtn', this.updateDisabledStatusAndResetBtn);

    this.stopListening(dispatcher, 'facette:dates:updateAvailableDates');
    this.listenTo(dispatcher, 'facette:dates:updateAvailableDates', this.updateAvailableDates);
  },

  /**
   * Initialize datepicker
   * @param self
   * @param {Object=} options
   */
  initDatepicker(self, options = {}) {
    // --- remove old calendars
    _.each(self.calendarsPicker, function (picker) {
      picker.destroy();
    });

    self.calendarsPicker = [];
    let visibleMonthsNb = 2;
    let durationDrawed = false;

    let firstAvailableDate = false;
    let lastAvailableDate = false;

    if (typeof arrAvailableDates !== 'undefined') { // arrAvailableDates = tableau des dates valides, crée dans un script de la page.
      firstAvailableDate = new Date(arrAvailableDates[0]);
      lastAvailableDate = arrAvailableDates.length > 1 ? new Date(arrAvailableDates[arrAvailableDates.length - 1]) : genericDate.addDays(new Date(arrAvailableDates[0]), 30);

      //nombre de mois à afficher = différence entre les mois +1 (pour afficher aussi le premier mois) + 12 fois diff entre les années
      visibleMonthsNb = genericDate.diff(firstAvailableDate, lastAvailableDate, 'months') + 1;
    }

    //handling arrival date picker
    const minDate = firstAvailableDate && firstAvailableDate > new Date() ? firstAvailableDate : new Date(),
      maxDate = lastAvailableDate ? lastAvailableDate : genericDate.addDays(new Date(), 365),
      pickerOptions = {
        minRange: null,
        numberOfMonths: DEVICE.isMobile ? visibleMonthsNb : 2,
        minDate: new Date(), // today
        maxDate: maxDate,
        defaultDate: minDate,
        position: typeof options.position !== 'undefined' ? options.position : 'bottom left',
        reposition: typeof options.reposition !== 'undefined' ? options.reposition : false,
        type: 'arrival'
      };

    const pickerEvents = {
      onSelect() {
        const arrivalDate = genericDate.format(this._d);

        if (DEVICE.isMobile) {
          dispatcher.trigger('duration:handleLoader', true);
        }

        self.$arrivalDate.val(genericDate.toDisplay(arrivalDate));
        self.$arrivalDateInput.val(arrivalDate);
        self.$arrivalDate.closest('.date-container').removeClass('opened');

        // Récupération du numéro lié au jour de la semaine pour afficher le nom du jour de la semaine à partir du regroupement de wording CPE_CALENDAR
        dispatcher.trigger('facette:dates:updateDateFieldLabel', arrivalDate, '.js-search-arrivalDay');

        const departureDate = null;
        const modelDatas = {'arrivalDate': arrivalDate, 'departureDate': departureDate};
        dispatcher.trigger('facette:flexPeriod:clean', true);

        self.temporaryModel.set(modelDatas, { 'silent': false });
        $('.js-search-departureInput').val(departureDate);

        if (!self.isDayVisitor) {
          //désactivation de la fonction hide pour éviter l'effet de clignotement entre les deux calendriers
          self.arrivalDatepicker.hide = () => {/*noop*/};

          //ajout d'un loader
          loader.display('.pika-single.arrival');

          //mise à jour du json du moteur de recherche
          self.departureDatepicker.setDate(departureDate, true);
          $('.js-search-date_end').val(genericDate.toDisplay(departureDate));
          dispatcher.trigger('facette:dates:updateDateFieldLabel', departureDate, '.js-search-departureDay');
          self.$departureDate.removeClass('disabled').prop('disabled', false);
          self.$departureDate.closest('.searchForm-inputContainer').removeClass('disabled');

          //reset departure date
          self.$departureDate.val('');
          self.$departureDateInput.val('');
          self.$departureDay.html('');
          self.$departureBlock.removeClass('dirty');

          loader.remove('.pika-single.arrival');

          if (typeof options.selectCallBack !== 'undefined') {
            options.selectCallBack();
          }

          const oDate = arrivalDate !== '' ? {key: arrivalDate, value: arrivalDate} : null;

          dispatcher.trigger('search:updateMainSearchStore', 'date', [oDate]);
        } else {
          self.temporaryModel.set({ 'arrivalDate': arrivalDate, 'departureDate': null }, { 'silent': false });
          dispatcher.trigger('search:getJsonDatas', { abortable: true, isFromDate: true });
          $('#mobileCalendar').removeClass('displayed');

          // Close calendars after animation
          setTimeout(() => {
            self.arrivalDatepicker.pickerClose();
          }, 700);
          dispatcher.trigger('search:toggler:render');
        }

        //showing reset button
        $('.searchForm-globalDateContainer .js-pika-reset').addClass('visible');

        // remove overlay only if 2 value are defined
        if (arrivalDate !== null && departureDate !== null) {
          $('body').removeClass('searchFocused');
        }
      },
      onOpen() {
        const arrivalDate = genericDate.format(new Date(self.$arrivalDateInput.val())),
          arrivalDateIsDate = genericDate.dateIsValid(new Date(arrivalDate));

        let departureDateIsDate = false;
        if (!self.isDayVisitor) {
          const departureDate = genericDate.format(new Date(self.$departureDateInput.val()));
          departureDateIsDate = genericDate.dateIsValid(new Date(departureDate));
          self.departureDatepicker.pickerClose();
          if (!$('.js-periodFlexType').length) {
            dispatcher.trigger('facette:flexPeriod:getDatas');
          }

        } else {
          departureDateIsDate = true;
        }

        if (arrivalDateIsDate && departureDateIsDate && DEVICE.isMobile) {
          dispatcher.trigger('facette:dates:displayCalendarValidation', true);
        }

        //ouverture du block ages si des selects ages doivent être remplis
        const nbKidNotFullfilled = $('.js-selectKidAge-container:not(.isKid):not(.isBaby)').length,
          nbKidMulticottageNotFullfilled = $('.js-selectKidAgeMulticottage-container:not(.isKid):not(.isBaby)').length;

        if ($('.searchForm-capacity').hasClass('opened') && nbKidNotFullfilled > 0 && nbKidMulticottageNotFullfilled > 0) {
          dispatcher.trigger('kidsAges:setAgesError', true);
        } else {
          //close all filters if any
          dispatcher.trigger('search:filters:close');

          //scrolling to displayed element
          dispatcher.trigger('searchView:scrollToFilter', $('#js-searchEngine'), $('.pika-single'));

          if (!SEARCH_SCRIPTS.IS_DAY_VISITOR) {
            //handling tracking
            Tracking.dataLayerPush({
              event: 'clickEvent',
              clickCode: 'clickMainSearch',
              gaCategory: PAGE_SCRIPTS.page_template,
              gaAction: 'Facette Date open',
              gaLabel: self.wordings.date_arrival_placeholder,
              gaValue: 1,
              page_type: PAGE_SCRIPTS.page_template,
              area: 'overlay start date',
              cta_clicked: 'select date'
            });
          }
        }

        const events = 'click touchend',
          selector = '.js-searchForm-departureDateBlock';
        $(document).off(events, selector).on(events, selector, () => {
          if (!arrivalDateIsDate) {
            $('body').removeClass('searchFocused');
          }
        });

        if (DEVICE.isMobile) {
          self.scrollToSelectedDate('.arrival');
        }
      },
      onDraw() {
        self.arrivalDatepicker.hide = () => {/*noop*/};
        if (!self.isDayVisitor) {
          self.departureDatepicker.hide =  () => {/*noop*/} ;
        }

        //handling kids age select condition
        if ($('.searchForm-capacity').hasClass('opened') && $('.js-selectKidAge-container:not(.isBaby):not(.isKid)').length) {
          $(self.arrivalDatepicker.el).addClass('u-Hidden--forced');
          self.$arrivalBlock.closest('.date-container').removeClass('opened');
        } else {
          $(self.arrivalDatepicker.el).removeClass('u-Hidden--forced');
        }
      },
      disableDayFn: function (date) {
        if (typeof arrAvailableDates !== 'undefined') {
          return !arrAvailableDates.includes(genericDate.format(date));
        } else {
          return false;
        }
      }
    };

    let pickerContext = {
      isDatePickerForSearchForm: true, //si le calendrier est issu d'une action sur un des éléments du searchForm
      topAdjustment: 12, //gestion de la position verticale du calendrier par rapport à l'élément ouvrant
      formSelector: self.$el.selector
    };

    $(document).off('click.trackingCloseStartDate', '.pika-single.arrival .js-pikaClose').on('click.trackingCloseStartDate', '.pika-single.arrival .js-pikaClose', () => {
      const eventType = 'click';
      Tracking.dataLayerPush({
        event: eventType,
        page_type: PAGE_SCRIPTS.page_template,
        area: 'overlay start date',
        cta_clicked: 'close'
      });
    });

    self.arrivalDatepicker = Form.Datepicker.create(self.$arrivalDate, pickerOptions, pickerEvents, pickerContext);

    //mémorisation des datepicker
    self.calendarsPicker.push(self.arrivalDatepicker);

    //affectation d'une classe identifiante pour les datepickers
    $(self.arrivalDatepicker.el).addClass('arrival');

    //if only 2 months is available, and if the customer choose the last day of the second month, we make sure he can book his departure date (in the 3rd month)
    if (DEVICE.isMobile && visibleMonthsNb < 3) {
      visibleMonthsNb = 3;
    }

    //handling departure date picker

    //In case of product overview, sometimes a bug happen and we don't get the right arrival value, so we have to get it from SEARCH_SCRIPTS
    //TODO : réintégrer ce comportement dans l'instanciation harmonisée des valeurs de chargement en phase 2
    let arrivalDate = self.$arrivalDateInput.val();
    if (SEARCH_SCRIPTS.DISPLAY_DATE_OVERVIEW === '1' && typeof PRODUCT_SCRIPTS !== 'undefined' && PRODUCT_SCRIPTS.PRODUCT_TAB === `tab_${GLOBAL_SCRIPTS.UNIVERS}_domain`) {
      arrivalDate = SEARCH_SCRIPTS.DATE_SELECTED;
    }

    if (!self.isDayVisitor) {
      const QuatrecentCinquanteDaysfromNow = genericDate.addDays(new Date(), 450);
      let lastAvailableDateEnd = false;
      if (typeof arrAvailableDatesEnd !== 'undefined') { //arrAvailableDatesEnd = tableau des dates de départ valides, crée dans un script de la page.
        lastAvailableDateEnd = arrAvailableDatesEnd.length ? new Date(arrAvailableDatesEnd[arrAvailableDatesEnd.length - 1]) : false;
      }

      const maxDateEnd = lastAvailableDateEnd ? (lastAvailableDateEnd > QuatrecentCinquanteDaysfromNow ? lastAvailableDateEnd : QuatrecentCinquanteDaysfromNow) : QuatrecentCinquanteDaysfromNow,
        pickerOptionsEnd = {
          numberOfMonths: DEVICE.isMobile ? visibleMonthsNb : 2,
          minDate: new Date(),
          maxDate: maxDateEnd,
          defaultDate: new Date(),
          position: typeof options.position !== 'undefined' ? options.position : 'bottom left',
          reposition: typeof options.reposition !== 'undefined' ? options.reposition : false,
          type: 'departure'
        };

      const pickerEndEvents = {
        onSelect() {
          const _dateEndPicker = this;
          let departureDate = genericDate.format(this._d);
          arrivalDate = self.$arrivalDateInput.val();

          if (DEVICE.isMobile) {
            dispatcher.trigger('duration:handleLoader', true);
          }

          // if selected date is before arrivalDate
          if (departureDate < arrivalDate) {
            self.departureDatepicker.hide = () => {/*noop*/};
            setTimeout(() => {
              self.arrivalDatepicker.setDate(departureDate);
            });
          } else {
            $('body').removeClass('searchFocused');
            let nights = genericDate.diff(new Date(arrivalDate), new Date(departureDate));

            // Mise à jour des valeurs
            self.temporaryModel.set({'departureDate': departureDate, 'nights': nights}, {'silent': false});
            self.$departureDate.val(genericDate.toDisplay(departureDate));
            self.$departureDateInput.val(departureDate);

            if (!DEVICE.isMobile) {
              self.handleCalendarDisplay('hide');
              self.$departureDate.closest('.date-container').removeClass('opened');
            } else {
              loader.remove('.pika-single.departure');
              _dateEndPicker.draw();
            }

            // Récupération du numéro lié au jour de la semaine pour afficher le nom du jour de la semaine à partir du regroupement de wording CPE_CALENDAR
            dispatcher.trigger('facette:dates:updateDateFieldLabel', departureDate, '.js-search-departureDay');

            // Handling stored search parameters
            const oDateEnd = departureDate !== '' ? {key: departureDate, value: departureDate} : null;
            dispatcher.trigger('search:updateMainSearchStore', 'dateend', [oDateEnd]);
          }
          // Lancement éventuel d'une fonction spécifique en callback de la sélection d'une date de fin
          // Passée en options dans l'instanciation du controller
          if (typeof options.endSelectCallBack !== 'undefined') {
            options.endSelectCallBack();
          }
        },
        onOpen() {
          const arrivalDate = genericDate.format(new Date(self.$arrivalDateInput.val())),
            departureDate = genericDate.format(new Date(self.$departureDateInput.val())),
            arrivalDateIsDate = genericDate.dateIsValid(new Date(arrivalDate)),
            departureDateIsDate = genericDate.dateIsValid(new Date(departureDate));

          self.arrivalDatepicker.pickerClose();

          loader.remove('.pika-single.arrival');

          if (arrivalDateIsDate && departureDateIsDate && DEVICE.isMobile) {
            dispatcher.trigger('facette:dates:displayCalendarValidation');
          }

          dispatcher.trigger('searchView:scrollToFilter', $('#js-searchEngine'), $('.pika-single'));

          if (!SEARCH_SCRIPTS.IS_DAY_VISITOR) {
            Tracking.dataLayerPush({
              event: 'clickEvent',
              clickCode: 'clickMainSearch',
              gaCategory: PAGE_SCRIPTS.page_template,
              gaAction: 'Facette date_end open',
              gaLabel: self.wordings.date_departure_placeholder,
              gaValue: 1,
              page_type: PAGE_SCRIPTS.page_template,
              area: 'overlay end date',
              cta_clicked: 'select date'
            });
          }
          durationDrawed = false;//reset durationDrawed

          if (DEVICE.isMobile) {
            self.scrollToSelectedDate('.departure');
          }
        },
        onDraw() {
          self.arrivalDatepicker.hide = function () {/*noop*/};
          self.departureDatepicker.hide = function () {/*noop*/};
          if (!DEVICE.isMobile) {
            durationDrawed = true; //update drawed status
          }
          //handling kids age select condition
          if ($('.searchForm-capacity').hasClass('opened') && $('.js-selectKidAge-container:not(.isBaby):not(.isKid)').length) {
            $(self.departureDatepicker.el).addClass('u-Hidden--forced');
            self.$departureBlock.closest('.date-container').removeClass('opened');
          } else {
            $(self.departureDatepicker.el).removeClass('u-Hidden--forced');
          }
        },
        disableDayFn: function (date) {
          if (typeof arrAvailableDatesEnd !== 'undefined') {
            let formatDate = genericDate.format(date);
            return !arrAvailableDatesEnd.includes(formatDate);
          } else {
            return false;
          }
        },
        onClose() {
          //if calendar closure whitout departure date
          if (self.$departureDateInput.val() === '') {
            self.temporaryModel.set('departureDate', null);
          }
        }
      };

      self.departureDatepicker = Form.Datepicker.create(self.$departureDate, pickerOptionsEnd, pickerEndEvents, pickerContext);
      self.calendarsPicker.push(self.departureDatepicker);
      //affectation d'une classe identifiante pour les datepickers
      $(self.departureDatepicker.el).addClass('departure');
    }

    //handling disabled status & reset button
    self.updateDisabledStatusAndResetBtn();

    //instanciation des comportements d'ouverture de calendrier sur l'ensemble du bloc (y compris flèche en after)
    let dateContainerClickTimeout = false;
    $('.date-container').off('click touchend').on('click touchend', e => {
      if (!dateContainerClickTimeout) {
        dateContainerClickTimeout = setTimeout(() => {
          const $clickContainer = $(e.target).hasClass('.date-container') ? $(e.target) : $(e.target).closest('.date-container');
          if ($clickContainer.hasClass('date-start')) {
            if (!self.$arrivalDate.is(':disabled') && !self.$arrivalDate.is('.disabled')) {
              self.handleCalendarDisplay('show', 'facette_date');
            }
          } else if (!self.$departureDate.is(':disabled') && !self.$departureDate.is('.disabled')) {
            self.handleCalendarDisplay('show', 'facette_date_end');
          } else {
            self.handleCalendarDisplay('show', 'facette_date');
          }

          clearTimeout(dateContainerClickTimeout);
          dateContainerClickTimeout = false;
        }, 100);
      }
    });

    $(document).on('click', '.cp-overlay', e => {
      e.preventDefault();

      // action when datepicker is open
      $('body').removeClass('searchFocused');
      // close lists on click outside (main function on resultlist file)
      dispatcher.trigger('searchView:closeLists');
      if (!DEVICE.isMobile) {
        self.handleCalendarDisplay('hide');
      }
    });

    //création du background pika
    if ($('.pika-background').length === 0 && !DEVICE.isMobile) {
      $('body').append('<div class="js-pika-background pika-background u-Hidden"></div>');
    }
  },

  /**
   * Update disabled status and reset button
   */
  updateDisabledStatusAndResetBtn: function () {
    //handling disabled status & reset button
    if (this.$arrivalDate.val() !== '' && this.$arrivalDate.val() !== this.$arrivalDate.attr('placeholder')) {
      this.$departureDate.removeClass('disabled').prop('disabled', false);
      this.$departureDate.closest('.searchForm-inputContainer').removeClass('disabled');
      $('.searchForm-globalDateContainer .js-pika-reset').addClass('visible');
    } else {
      $('.searchForm-globalDateContainer .js-pika-reset').removeClass('visible');
    }
  },

  /**
   * Display calendar validation button
   * @param {Boolean=} onArrivalDatePicker
   */
  displayCalendarValidation: function (onArrivalDatePicker = false) {
    const $validateCalendar = `
      <div class="searchForm-submitContainer calendarValidate u-Visible-mobile">
        <button type="button" class="js-submitCalendar submitSearchEngine button--pinkWhite">
          ${this.wordings.filter_validate_label}
        </button>
      </div>`;

    onArrivalDatePicker ? this.arrivalDatepicker.el.innerHTML += $validateCalendar : this.departureDatepicker.el.innerHTML += $validateCalendar;

    $('.js-submitCalendar').on('click touchend', () => {
      $('.pika-single.is-bound .pika-header').removeClass('show');
      $('#mobileCalendar').removeClass('displayed');
      $('.searchForm-submitContainer.calendarValidate').hide();

      //Close calendars after animation
      setTimeout(() => {
        onArrivalDatePicker ? this.arrivalDatepicker.hide = this.arrivalDatepicker.pickerClose : this.departureDatepicker.hide = this.departureDatepicker.pickerClose;
        this.arrivalDatepicker.pickerClose();
        this.departureDatepicker.pickerClose();
      }, 700);
    });
  },

  /**
   * Update date field label (day name)
   * @param {String} date - xx/xx/xxxx
   * @param {String} inputSelector
   */
  updateDateFieldLabel: function (date, inputSelector) {
    const $input = this.$el.find(inputSelector);

    if (date !== '') {
      // We use localtime to show day name depend on the current market and language
      const localTimezone = `${GLOBAL_SCRIPTS.LANGUAGE_CODE}-${GLOBAL_SCRIPTS.MARKET_CODE}`;
      const label = new Date(date).toLocaleDateString(localTimezone, {weekday: 'long'}).replace(/\./gi, '');

      $input.html(label);
    } else {
      $input.html('');
    }

    // Update item state (is dirty)
    $input.closest('.searchForm-inputContainer').toggleClass('dirty', !DEVICE.isMobile && date !== '');
  },

  /**
   * Update available dates
   * @param {Array} dateList
   * @param {String} type - arrival / departure
   */
  updateAvailableDates: function (dateList, type) {
    const arrDates = _.map(dateList, 'key');

    if (type === 'arrival') {
      arrAvailableDates = arrDates;
    } else if (type === 'departure' && typeof arrAvailableDatesEnd !== 'undefined') {
      arrAvailableDatesEnd = arrDates;
    }
  },

  /**
   * Reset Arrival and Departures dates
   */
  resetDate: function (resetDatas = true) {
    this.arrivalDatepicker.hide = this.arrivalDatepicker.pickerClose;
    this.departureDatepicker.hide = this.departureDatepicker.pickerClose;

    // Par défaut, on n'efface que la date de fin (cas le plus courant)
    if (resetDatas) {
      this.temporaryModel.set({'departureDate': null, 'arrivalDate': null});
      dispatcher.trigger('search:updateMainSearchStore', 'dateend', null);
      dispatcher.trigger('search:updateMainSearchStore', 'date', null);
      dispatcher.trigger('facette:flexPeriod:clean');
    }

    this.calendarsPicker[1].setDate(null); // departure
    this.calendarsPicker[0].setDate(null); // arrival
    this.$arrivalDate.val('');
    this.$departureDate.val('');
    this.$departureDate.addClass('disabled').prop('disabled', true);
    this.$departureDate.closest('.searchForm-inputContainer').addClass('disabled');
    this.$arrivalDateInput.val('');
    this.$departureDateInput.val('');
    this.$arrivalBlock.removeClass('dirty');
    this.$departureBlock.removeClass('dirty');
    this.$arrivalDay.empty();
    this.$departureDay.empty();

    if (DEVICE.isMobile) {
      // refreshing calendar display on mobile
      this.calendarsPicker[0].show(0);
      this.calendarsPicker[1].hide = this.departureDatepicker.pickerClose;
    }

    $('button.pika-day').removeClass('pika-selectedEndDay pika-selectedRange pika-selectedDay');
    $('.pika-single td').removeClass('pika-selectedDayContainer pika-selectedEndDayContainer pika-selectedRangeContainer');

  },

  /**
   * Reset Departure date
   * @param self
   * @param {String} arrivalDate
   * @param {Function|String} callbackFct
   */
  resetDepartureDate: function (self, arrivalDate = '', callbackFct = false) {
    self.datePickersView.departureDatepicker.setDate(null);
    self.datePickersView.$departureDate.removeClass('disabled').prop('disabled', false);
    self.datePickersView.$departureDate.closest('.searchForm-inputContainer').removeClass('disabled');
    self.datePickersView.$departureDate.val('');
    self.datePickersView.$departureDateInput.val('');
    self.datePickersView.$departureDay.html('');
    self.datePickersView.$departureBlock.removeClass('dirty');

    self.datePickersView.departureDatepicker.setMinDate(new Date());
    self.datePickersView.departureDatepicker.setStartRange(new Date());
    dispatcher.trigger('search:updateMainSearchStore', 'dateend', null);

    if (typeof callbackFct === 'function') {
      callbackFct();
    } else if (typeof callbackFct === 'string') {
      dispatcher.trigger(callbackFct);
    }
  },

  /**
   * Gestion de l'interaction d'affichage des calendriers
   * @desc !!! La classe permettant de sélectionner l'input de date de fin doit obligatoirement comporter la chaine '_end'
   * @param {String} action - hide / show / reset
   * @param {String} classes - Ending date class must contain "_end" string
   */
  handleCalendarDisplay(action, classes) {
    const self = this;

    switch (action) {
      case 'hide' :
        if (typeof classes !== 'undefined') {
          if (classes.indexOf('_end') > -1) {
            self.departureDatepicker.pickerClose();
          } else {
            self.arrivalDatepicker.pickerClose();
          }
        } else {
          self.arrivalDatepicker.pickerClose();

          if (!self.isDayVisitor) {
            self.departureDatepicker.pickerClose();
          }

          $('#js-searchEngine').removeClass('showCalendar');
          $('.date-container').removeClass('opened');
        }

        break;
      case 'show':
        if ($('.searchForm-capacity').hasClass('opened')) {
          $('.searchForm-block--capacity .js-searchForm-dataOpener').click();
        }
        if (classes.indexOf('_end') > -1) {
          if (!self.$departureDate.is(':disabled')) {
            self.arrivalDatepicker.pickerClose();
            self.departureDatepicker.show(0);
          }
        } else {
          self.arrivalDatepicker.show(0);
        }
        // Close all sorts when opening calendar
        dispatcher.trigger('searchView:closeSorts');

        break;
      case 'reset' :
        self.$arrivalDateInput.val('');
        this.$arrivalDate.val('');

        if (!self.isDayVisitor) {
          self.$departureDateInput.val('');
          this.$departureDate.val('');
        }

        self.initDatepicker(self, self.datePickerOptions);
        self.arrivalDatepicker.show(0);

        if (!self.isDayVisitor) {
          self.$departureDate.addClass('disabled').prop('disabled', true);
          self.$departureDate.closest('.searchForm-inputContainer').addClass('disabled');
        }

        break;
    }
  },

  /**
   * Update datepicker in callback or after an external action
   * @param {String} dateType - (mandatory) - arrivalDate / departureDate
   * @param {String} value - (mandatory) - xx/xx/xxxx
   * @param {Boolean=} silent
   */
  updateDate(dateType, value, silent = false) {
    const datePicker = dateType === 'arrivalDate' ? this.arrivalDatepicker : this.departureDatepicker;
    const $inputDateDisplay = dateType === 'arrivalDate' ? this.$arrivalDate : this.$departureDate;
    const $inputDate = dateType === 'arrivalDate' ? this.$arrivalDateInput : this.$departureDateInput;
    const $inputDay = dateType === 'arrivalDate' ? this.$arrivalDay : this.$departureDay;

    $inputDate.val(value);
    datePicker.setDate(value, silent);
    $inputDateDisplay.val(genericDate.toDisplay(value));
    dispatcher.trigger('facette:dates:updateDateFieldLabel', value, $inputDay);
  },

  /**
   * Scroll to selected date on mobile
   * @param {String} calendarSelector
   */
  scrollToSelectedDate(calendarSelector) {
    const $pikaSingle = $('.pika-single' + calendarSelector),
      $selectedDate = $pikaSingle.find('.pika-selectedDayContainer');

    $pikaSingle.scrollTop($selectedDate.length ? $selectedDate.parents('.pika-lendar').position().top + $pikaSingle.scrollTop() - $pikaSingle.find('.pika-header').height() : 0);
  }
});